import { render, staticRenderFns } from "./omt-select.vue?vue&type=template&id=c38b66cc&scoped=true&"
import script from "./omt-select.vue?vue&type=script&lang=js&"
export * from "./omt-select.vue?vue&type=script&lang=js&"
import style0 from "./omt-select.vue?vue&type=style&index=0&id=c38b66cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38b66cc",
  null
  
)

export default component.exports